import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { Router, Route} from 'react-router-dom';
import theme from './theme';
import history from './history';
import AppHeader from './component/AppHeader';
import Loader from './component/Loader';
import auth from "./auth";

const Login = lazy(() => import('./view/Login'));
const SignUp = lazy(() => import('./view/SignUp'));
const Forgot = lazy(() => import('./view/Forgot'));
const Dashboard = lazy(() => import('./view/Dashboard'));
const Support = lazy(() => import('./view/Support'));
const Websites = lazy(() => import('./view/Websites'));
const CheckoutSuccess = lazy(() => import('./view/CheckoutSuccess'));
const NewWebsite = lazy(() => import('./view/NewWebsite'));
const SetupWebsite = lazy(() => import('./view/SetupWebsite'));
const ResetPassword = lazy(() => import('./view/ResetPassword'));
const ConfirmEmail = lazy(() => import('./view/ConfirmEmail'));
const Report = lazy(() => import('./view/Report'));



ReactDOM.render(
  
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Router history={history}>
      <Suspense fallback={<div><AppHeader/><div style={{margin: 0, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)'}}><Loader/></div></div>}>
          <Route path="/dashboard" component={Dashboard} exact />
          <Route path="/websites" component={Websites} exact />
          <Route path="/support" component={Support} exact />
          <Route path="/login" component={Login} exact />
          <Route path="/signup" component={SignUp} exact />
          <Route path="/checkout_success" component={CheckoutSuccess} exact />
          <Route path="/new_website" component={NewWebsite} exact />
          <Route path="/setup_website" component={SetupWebsite} exact />
          <Route path="/confirm_email" component={ConfirmEmail} exact />
          <Route path="/reset_password" component={ResetPassword} exact />
          <Route path="/forgot_password" component={Forgot} exact />
          <Route path="/report" component={Report} exact />
        </Suspense>
    </Router>
  </ThemeProvider>,
  document.querySelector('#root'),
);
